import { useContext } from "react";
import { AppContext } from "AppProvider/AppContext";

const useFindBuyerName = () => {
  const { bapIds } = useContext(AppContext);
  return (bap_id: string) => {
    const matchedBuyer = bapIds.find((buyer: any) => buyer.bap_id === bap_id);
    return matchedBuyer?.name ? matchedBuyer?.name : matchedBuyer?.bap_id || "NA";
  };
};

export default useFindBuyerName;
